"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var end2end_1 = require("@hudled/end2end");
var material_1 = require("@mui/material");
var firestore_1 = require("firebase/firestore");
var react_redux_1 = require("react-redux");
var Button_1 = __importDefault(require("atomicComponents/atoms/Buttons/Button"));
var Heading_1 = __importDefault(require("shared/components/Heading"));
var Modal_1 = __importDefault(require("shared/components/Modal/Modal"));
var Text_1 = __importDefault(require("shared/components/Text"));
var dateTime_1 = require("utils/dateTime");
var hooks_1 = require("utils/hooks");
var single_1 = require("utils/selectors/single");
var FeatureList_1 = __importDefault(require("./styles/FeatureList"));
var FeatureListItem_1 = __importDefault(require("./styles/FeatureListItem"));
var FreeTrialPlanModal = function (_a) {
    var open = _a.open, onClose = _a.onClose;
    var profile = (0, react_redux_1.useSelector)(single_1.selectProfileWithId);
    var _b = __read((0, hooks_1.useSubmitter)('companies', profile === null || profile === void 0 ? void 0 : profile.companyId), 1), companySubmitter = _b[0];
    var handleStartFreeTrial = function () {
        var freeTrialStartDate = firestore_1.Timestamp.now();
        var freeTrialFinishDate = firestore_1.Timestamp.fromDate((0, dateTime_1.addDays)(new Date(), end2end_1.GROWTH_FREE_TRIAL_PERIOD));
        var planData = {
            freeTrialStartDate: freeTrialStartDate,
            freeTrialFinishDate: freeTrialFinishDate,
            planStatus: 'in_trial', plan: 'Growth',
        };
        return companySubmitter(planData);
    };
    return ((0, jsx_runtime_1.jsx)(Modal_1.default, __assign({ label: "Start a Free Trial Plan", onClose: onClose, open: open }, { children: (0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ p: 4 }, { children: [(0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ width: "95%" }, { children: [(0, jsx_runtime_1.jsx)(Heading_1.default, __assign({ level: 2 }, { children: "Start a 14 day free trial of our growth plan today" })), (0, jsx_runtime_1.jsx)(material_1.Box, __assign({ mt: 2 }, { children: (0, jsx_runtime_1.jsx)(Text_1.default, __assign({ level: 2 }, { children: "No credit card required." })) })), (0, jsx_runtime_1.jsx)(material_1.Box, __assign({ mt: 2 }, { children: (0, jsx_runtime_1.jsx)(Text_1.default, __assign({ level: 1 }, { children: "Additional features" })) }))] })), (0, jsx_runtime_1.jsxs)(FeatureList_1.default, { children: [(0, jsx_runtime_1.jsx)(FeatureListItem_1.default, { title: "Export software stack" }), (0, jsx_runtime_1.jsx)(FeatureListItem_1.default, { title: "Unlimited employee surveys" }), (0, jsx_runtime_1.jsx)(FeatureListItem_1.default, { title: "Advanced spend alerts" }), (0, jsx_runtime_1.jsx)(FeatureListItem_1.default, { title: "Unlimited users" }), (0, jsx_runtime_1.jsx)(FeatureListItem_1.default, { title: "Advanced saving recommendations" }), (0, jsx_runtime_1.jsx)(FeatureListItem_1.default, { title: "Exclusive deals & discounts" }), (0, jsx_runtime_1.jsx)(FeatureListItem_1.default, { title: "Chat support" })] }), (0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ mt: 2, display: "flex", alignItems: "center", flexDirection: "column" }, { children: [(0, jsx_runtime_1.jsx)(Button_1.default, __assign({ onClick: handleStartFreeTrial }, { children: "Start trial" })), (0, jsx_runtime_1.jsx)(material_1.Box, __assign({ mt: 1 }, { children: (0, jsx_runtime_1.jsx)(Text_1.default, __assign({ level: 2 }, { children: "$50 USD/month after trial period" })) }))] }))] })) })));
};
exports.default = FreeTrialPlanModal;
